import { inject, Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { map, Observable } from 'rxjs';
import { SetMaintenanceWorkStatus } from './maintenance-work.actions';
import { isMaintenanceWorkCookieSet } from './maintenance.utils';

@Injectable({
  providedIn: 'root',
})
export class MaintenanceWorkFacade {
  public statusMessage$: Observable<string>;
  public get statusMessage(): string {
    return this.#store.selectSnapshot((state) => state.maintenanceWork.statusMessage);
  }
  public maintenanceActive$: Observable<boolean>;
  public get maintenanceActive(): boolean {
    return this.#store.selectSnapshot((state) => state.maintenanceWork.maintenanceActive);
  }
  public isLoginDisabled$: Observable<boolean>;

  readonly #store = inject(Store);

  constructor() {
    this.statusMessage$ = this.#store.select((state) => state.maintenanceWork?.statusMessage ?? '');
    this.maintenanceActive$ = this.#store.select((state) => !!state.maintenanceWork?.maintenanceActive);
    this.isLoginDisabled$ = this.maintenanceActive$.pipe(map((maintenanceActive) => !isMaintenanceWorkCookieSet() && maintenanceActive));
  }

  public setMaintenanceWorkStatus(maintenanceActive: boolean, statusMessage: string) {
    this.#store.dispatch(new SetMaintenanceWorkStatus({ maintenanceActive, statusMessage }));
  }
}
